export default __webpack_public_path__ + "static/media/darrow.748bc630.svg";